import { NOTES_HARD_OFF } from './notes-flag';

/**
 * Gate for the Account/Contact Notes surface. Notes is on for every rep;
 * `NOTES_HARD_OFF` is the one kill switch. Callers (tab, thread/summaries
 * queries, read-mark POSTs) must use `enabled` to turn network off, not just
 * hide UI.
 */
export function useNotesEnabled(): { enabled: boolean } {
  return { enabled: !NOTES_HARD_OFF };
}
